import { Download } from 'lucide-react';
import { useInstallPrompt } from '@/hooks/useInstallPrompt';
import { Button } from '@/components/ui/button';
import { toast } from 'sonner';

interface InstallButtonProps {
  variant?: 'default' | 'compact';
}

export function InstallButton({ variant = 'default' }: InstallButtonProps) {
  const { isInstallable, isInstalled, promptInstall } = useInstallPrompt();

  // Don't show if already installed or not installable
  if (isInstalled || !isInstallable) return null;

  const handleInstall = async () => {
    const result = await promptInstall();
    if (result.success) {
      toast.success('Park Row app installed!');
    }
  };

  if (variant === 'compact') {
    return (
      <button
        onClick={handleInstall}
        className="p-2 text-muted-foreground hover:text-foreground transition-colors touch-target tap-highlight-none"
        aria-label="Install App"
      >
        <Download className="h-5 w-5" />
      </button>
    );
  }

  return (
    <Button
      onClick={handleInstall}
      variant="outline"
      size="sm"
      className="gap-2"
    >
      <Download className="h-4 w-4" />
      Install App
    </Button>
  );
}
